import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "./apiClient";

// ------------------ Thunks ------------------

// Fetch all domains
export const fetchDomains = createAsyncThunk("domains/fetchDomains", async (_, { rejectWithValue }) => {
  try {
    const response = await apiClient.get("/domains/");
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message);
  }
});

// Insert a new domain
export const insertDomain = createAsyncThunk("domains/insertDomain", async (domain, { rejectWithValue }) => {
  try {
    const response = await apiClient.post("/domains/", domain);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message);
  }
});

// Delete a domain
export const deleteDomain = createAsyncThunk("domains/deleteDomain", async (id, { rejectWithValue }) => {
  try {
    await apiClient.delete(`/domains/${id}/`);
    return id;
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message);
  }
});

// Update a domain
export const updateDomain = createAsyncThunk("domains/updateDomain", async (domain, { rejectWithValue }) => {
  try {
    const response = await apiClient.put(`/domains/${domain.id}/`, domain);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message);
  }
});

// ------------------ Slice ------------------

const domainsSlice = createSlice({
  name: "domains",
  initialState: {
    domains: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDomains.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDomains.fulfilled, (state, action) => {
        state.loading = false;
        state.domains = action.payload;
      })
      .addCase(fetchDomains.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(insertDomain.fulfilled, (state, action) => {
        state.domains.push(action.payload);
      })
      .addCase(insertDomain.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(deleteDomain.fulfilled, (state, action) => {
        state.domains = state.domains.filter((domain) => domain.id !== action.payload);
      })
      .addCase(deleteDomain.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(updateDomain.fulfilled, (state, action) => {
        const index = state.domains.findIndex((domain) => domain.id === action.payload.id);
        if (index !== -1) {
          state.domains[index] = action.payload;
        }
      })
      .addCase(updateDomain.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default domainsSlice.reducer;
